import {SetGetSupportList} from './thunk/setGetSupportList';
import {SetGetSupportView} from './thunk/setGetSupportView';
import {SetPostSupportUpdateStatus} from './thunk/setPostSupportUpdateStatus';

export const Thunks = {
    SetGetSupportList,
    SetGetSupportView,
    SetPostSupportUpdateStatus
}